import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a00bb2bf6558f0014fd8e94_1780601065204_ab678540/clinigolhub/src/app/sign-up-login/components/AuthScreen.tsx");
